import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { getAssetNumber } from '../../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'
import { selectLatestRatesBidAsk } from '../../../../../../store/redusers/assets/selectors'
import { selectPosition } from '../../../../../../store/redusers/positions/selectors'

const TableCellNow = ({cell, positionId}) => {
	const position = useSelector(selectPosition('pending', positionId))
	const isAsk = position.bid_ask_pending === ' (ask)'
	const isBid = position.bid_ask_pending === ' (bid)'
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk(position.asset_id))
	const rate = isAsk ?
		latestRatesBidAsk.ask :
		(isBid ? latestRatesBidAsk.bid : 'N/A')
	const up = isAsk ?
		latestRatesBidAsk.askUp :
		(isBid ? latestRatesBidAsk.bidUp : undefined)
	const { theme } = useDefaultComponentTools()
	const valueNow = getAssetNumber(rate, up, theme.palette.text.primary, theme.palette.red,
		theme.palette.green, position.bid_ask_pending, true)

	return (
		<Box
			align='right'
			sx={{
				m: '0 4px',
				minWidth: `calc(${cell.width} - 8px)`
			}}
		>
			<Box sx={{display: 'flex', justifyContent: 'center'}}>
				<Typography
					variant='subtitle1'
					component='span'
					sx={{
						alignItems: 'center',
						display: 'flex',
						justifyContent: 'center',
						ml: 0,
						textAlign: 'center',
						width: '100%'
					}}
				>
					{position.canceled ? position.now : valueNow}
				</Typography>
			</Box>
		</Box>
	)
}

TableCellNow.propTypes = {
	cell: PropTypes.object,
	positionId: PropTypes.string
}

export default TableCellNow
